import { render, staticRenderFns } from "./loginBack.vue?vue&type=template&id=23e96050&scoped=true"
import script from "./loginBack.vue?vue&type=script&lang=js"
export * from "./loginBack.vue?vue&type=script&lang=js"
import style0 from "./loginBack.vue?vue&type=style&index=0&id=23e96050&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e96050",
  null
  
)

export default component.exports